import { Box, Divider, InputAdornment, ListItemIcon, Menu, MenuItem, Toolbar, Typography } from '@mui/material'
import { icons } from '../../constants/images'
import { getProfile, logout } from '../../utils/app.utils'
import { Logout, PersonAdd } from '@mui/icons-material'
import React from 'react'
import { useSelector } from 'react-redux'
import InputTextField from '../input/inputTextField'
interface propsTypes {
  setDrawerOpen: any
  drawerOpen: boolean
}
export default function Header(props: propsTypes) {
  const { profile } = useSelector((state: any) => state.profile)
  const { setDrawerOpen, drawerOpen } = props
  // const profile = JSON.parse(getProfile() || '')
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Toolbar sx={{
      width: "100%", borderBottom: '1px solid var(--C1, #026735)',
      boxShadow: '0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px -1px rgba(16, 24, 40, 0.10)',
      padding: '12px 44px !important',
      justifyContent: "space-between"
    }}>
      <div style={{ display: 'flex', alignItems: "center", padding: "12px 0px" }}>
        <icons.burgerMenu onClick={() => setDrawerOpen(!drawerOpen)} />
        {/* <InputTextField placeholder='ค้นหา' style={{ width: '376px', marginLeft: '20px' }} inputProps={{
          ...{ style: { padding: "0px" } },

        }} InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <icons.search />
            </InputAdornment>
          ),
        }} /> */}
      </div>
      <div style={{ display: 'flex', alignItems: "center" }}>
        <icons.noti />
        <Divider orientation="vertical" variant="fullWidth" flexItem sx={{
          background: 'var(--background-light-disabled, #E5E5E7)', borderWidth: "1px", marginLeft: '12px',
          marginRight: '12px',
        }} />
        <div onClick={handleClick} style={{ display: 'flex', alignItems: "center", cursor: "pointer" }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: "42px",
            height: '42px',
            borderRadius: 'var(--roundness-full-inside, 128px)',
            borderTop: '1px solid var(--stroke-light-base, #E5E5E7)',
            borderRight: '1px solid var(--stroke-light-base, #E5E5E7)',
            borderBottom: '1px solid var(--stroke-light-base, #E5E5E7)',
            borderLeft: '1px solid var(--stroke-light-base, #E5E5E7)',
            background: 'var(--background-light-base-second, #F8F9FB)',
          }}>
            <icons.userFill />
          </div>

          <Box sx={{ marginLeft: '8px', marginRight: "8px", display: { md: 'block', xs: 'none' } }}>
            <Typography sx={{ color: "#026735" }}>{profile?.employeeFirstname} {profile?.employeeLastname}</Typography>
            <Typography sx={{ color: "#858C95", fontSize: '12px' }}>{profile?.department?.departmentName}</Typography>
          </Box>
          <icons.profileDown />
        </div>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          {/* <MenuItem onClick={() => {}}>
          <ListItemIcon>
            <PersonAdd fontSize="small" />
          </ListItemIcon>
          บัญชีผู้ใช้
        </MenuItem> */}
          <MenuItem onClick={() => logout()}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            ออกจากระบบ
          </MenuItem>
        </Menu>
      </div>

    </Toolbar>
  )
}
